import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Masonry } from "@mui/lab"
import { Box, Typography } from "@mui/material"
import DeliveryOrShippingCard from "./options/DeliveryOrShippingCard"
import SpecialEventsCard from "./options/SpecialEventsCard"
import WarehousePickupCard from "./options/WarehousePickupCard"
import { setCart } from "src/features/checkout/checkoutSlice"
import analytics from "src/app/analytics"
import { useCartLinesRemoveMutation } from "src/features/checkout/storefrontCartApi"

export default function Options() {
  const dispatch = useDispatch()
  const cart = useSelector((state) => state.checkout.cart)

  const [cartLinesRemove] = useCartLinesRemoveMutation()

  useEffect(() => {
    document.title = "Options - Kakaako Wine - Checkout"

    analytics.track("page_view", {
      cart_id: cart.id,
      page_title: "Options",
      page_location: window.location.href,
    })

    const hawaiiGetLineItem = cart.lines.edges.find((item => item.node?.merchandise?.product?.title === 'General Excise Tax'))

    // If a user navigates back to options page, and Hawaii GET has been previously added, remove it from the checkout.
    if (hawaiiGetLineItem) {
      cartLinesRemove({
        cartId: cart.id,
        lineIds: [hawaiiGetLineItem.node.id]
      }).then((res) => {
        if (res.data?.cartLinesRemove?.cart) dispatch(setCart(res.data.cartLinesRemove.cart))
      })
    }
  }, [])

  return (
    <Box>
      <Typography component="h2" variant="h5" gutterBottom>
        Options
      </Typography>
      <Masonry
        columns={{ lg: 2, md: 1, sm: 2, xs: 1 }}
        spacing={2}
        // sx={{ m: 0, mt: 1 }}
        // Set defaults to minimize rendering issue.
        defaultHeight={600}
        defaultColumns={2}
        defaultSpacing={2}
      >
        <DeliveryOrShippingCard />
        <WarehousePickupCard />
        <SpecialEventsCard />
      </Masonry>
    </Box>
  )
}
